var map = {
	"./flags/en.svg": 843,
	"./flags/es.svg": 844,
	"./flags/fr.svg": 845,
	"./flags/it.svg": 846,
	"./flags/nl.svg": 847,
	"./flags/pt.svg": 848,
	"./icons/icon-arrow-down.svg": 137,
	"./icons/icon-arrow-up.svg": 138,
	"./icons/icon-beach--green.svg": 849,
	"./icons/icon-beach--red.svg": 850,
	"./icons/icon-beach.svg": 851,
	"./icons/icon-break.svg": 852,
	"./icons/icon-chevron-circle-left.svg": 853,
	"./icons/icon-chevron-circle-right.svg": 854,
	"./icons/icon-info--circle.svg": 855,
	"./icons/icon-legend-buoys.svg": 856,
	"./icons/icon-legend-star.svg": 857,
	"./icons/icon-legend-swell-arrow.svg": 858,
	"./icons/icon-legend-swell.svg": 859,
	"./icons/icon-legend-wind.svg": 860,
	"./icons/icon-point--green.svg": 861,
	"./icons/icon-point--red.svg": 862,
	"./icons/icon-point.svg": 863,
	"./icons/icon-reef--green.svg": 864,
	"./icons/icon-reef--red.svg": 865,
	"./icons/icon-reef.svg": 866,
	"./icons/icon-river--green.svg": 867,
	"./icons/icon-river--red.svg": 868,
	"./icons/icon-river.svg": 869,
	"./icons/icon-sandbar--green.svg": 870,
	"./icons/icon-sandbar--red.svg": 871,
	"./icons/icon-sandbar.svg": 872,
	"./icons/icon-tidal-range--blue.svg": 873,
	"./icons/icon-tide-clock--color.svg": 874,
	"./icons/icon-tide-needle.svg": 875,
	"./icons/icon-tide-star.svg": 876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;